const leadform = [
    {
        selector: '[data-react="leadform"]',
        path: { dirname: 'forms/react', filename: 'App' },
    },
];

export { leadform };
